var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("资产报废单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.scrapVoucher, rules: _vm.voucherInfo }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("机构信息")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "srcComName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.scrapVoucher.comFullName,
                          callback: function($$v) {
                            _vm.$set(_vm.scrapVoucher, "comFullName", $$v)
                          },
                          expression: "scrapVoucher.comFullName"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.srcCheck
                        ? _c("i", {
                            staticClass:
                              "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                            on: { click: _vm.selectSrcComName }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.showBizUnitWarehouse && !_vm.srcCheck
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [_vm._v("仓库")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "warehouseId" } },
                        [
                          _c(
                            "el-select",
                            {
                              on: { change: _vm.warehouseChange },
                              model: {
                                value: _vm.warehouseId,
                                callback: function($$v) {
                                  _vm.warehouseId = $$v
                                },
                                expression: "warehouseId"
                              }
                            },
                            _vm._l(_vm.warehouseList, function(item) {
                              return _c("el-option", {
                                attrs: { label: item.name, value: item.id }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("申请原因")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "applyDesc" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请填写报废原因及数量说明",
                          type: "textarea",
                          resize: "both"
                        },
                        model: {
                          value: _vm.scrapVoucher.applyDesc,
                          callback: function($$v) {
                            _vm.$set(_vm.scrapVoucher, "applyDesc", $$v)
                          },
                          expression: "scrapVoucher.applyDesc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("成本中心")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.scrapVoucher.costCenterCode || ""))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [_c("label")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "span",
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.scrapVoucher.autoMaskAsIdle,
                          callback: function($$v) {
                            _vm.$set(_vm.scrapVoucher, "autoMaskAsIdle", $$v)
                          },
                          expression: "scrapVoucher.autoMaskAsIdle"
                        }
                      },
                      [_vm._v("自动标记闲置")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            !_vm.srcCheck
              ? _c(
                  "button",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: {
                      click: function($event) {
                        _vm.showDeviceListDlg()
                      }
                    }
                  },
                  [_c("span", [_vm._v("通用选择")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.scrapVoucher.itemList.length > 0
              ? _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.setStaff } },
                  [_c("span", [_vm._v("设置人员")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.scrapVoucher.itemList.length > 0 && !_vm.srcCheck
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.setScrapCause }
                  },
                  [_c("span", [_vm._v("设置报废原因")])]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "right" }, [
          _c("span", { staticClass: "mr10" }, [
            _vm._v(
              "报废金额：(" + _vm._s(_vm.scrapVoucher.splittedAmount || 0) + ")"
            )
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "已选择(" + _vm._s((_vm.scrapVoucher.itemList || []).length) + ")"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-form",
            { ref: "deviceInfo", attrs: { model: _vm.scrapVoucher } },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.scrapVoucher.itemList.slice(
                      _vm.startIndex,
                      _vm.endIndex
                    ),
                    maxHeight: "500",
                    border: "",
                    "tooltip-effect": "dark",
                    "header-cell-class-name": _vm.required
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "innerCode",
                      width: "180",
                      label: "资产编号",
                      fixed: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.viewAssetInfo(rows.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(rows.row.innerCode))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "innerNo",
                      width: "250",
                      label: "外部资产编码"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "assetType",
                      width: "100",
                      label: "管理方式",
                      align: "center",
                      fixed: "left"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.assetTypeMap[rows.row.assetType])
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "title",
                      width: "200",
                      label: "资产描述全称"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "fixedSpec",
                      width: "160",
                      label: "规格"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "assetNature",
                      width: "100",
                      label: "资产属性"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.assetNatureMap[rows.row.assetNature])
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "splitible",
                      width: "100",
                      label: "控制方式"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(rows.row.splitible ? "按金额" : "按数量")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "maxQuantity",
                      width: "100",
                      label: "可报废数量",
                      "render-header": _vm.floatIcon
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.maxQuantity || 0))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "quantity",
                      width: "100",
                      label: "报废数量"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("el-input", {
                              staticClass: "text-right",
                              attrs: {
                                type: "number",
                                min: "1",
                                disabled:
                                  rows.row.assetType == 0 ||
                                  rows.row.splitible ||
                                  _vm.srcCheck
                              },
                              on: {
                                change: function($event) {
                                  _vm.changeQuantity(rows.row)
                                }
                              },
                              model: {
                                value: rows.row.quantity,
                                callback: function($$v) {
                                  _vm.$set(rows.row, "quantity", $$v)
                                },
                                expression: "rows.row.quantity"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "orgWorth",
                      width: "80",
                      label: "资产原值(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.orgWorthKz != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.orgWorthKz.toFixed(2)))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "orgWorth",
                      width: "80",
                      label: "资产净值(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.netWorthKz != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.netWorthKz.toFixed(2)))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "splittedAmount",
                      width: "100",
                      label: "报废原值(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: rows.row.splittedAmount,
                                  expression: "rows.row.splittedAmount",
                                  modifiers: { number: true }
                                }
                              ],
                              staticClass: "input-content-right",
                              staticStyle: { width: "90%" },
                              attrs: {
                                disabled:
                                  !rows.row.splitible ||
                                  rows.row.assetType == 0 ||
                                  _vm.srcCheck,
                                type: "number",
                                min: "0"
                              },
                              domProps: { value: rows.row.splittedAmount },
                              on: {
                                change: function($event) {
                                  _vm.changeSplittedAmount(rows.row)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "splittedAmount",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "netWorth",
                      width: "80",
                      label: "报废金额(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.netWorth != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "durableLife",
                      width: "100",
                      label: "使用年限(月)"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "durableYears",
                      width: "100",
                      label: "已用年限(月)"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "deprTiming",
                      width: "100",
                      label: "报废时效类型"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.deprTiming != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.scrapDeprTimingMap[
                                        rows.row.deprTiming
                                      ]
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "fiscalInTime",
                      width: "140",
                      label: "入账时间"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.fiscalInTime != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.fiscalInTime))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "scrapCause",
                      width: "160",
                      label: "报废原因"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择",
                                  disabled: _vm.srcCheck
                                },
                                model: {
                                  value: rows.row.scrapCause,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "scrapCause", $$v)
                                  },
                                  expression: "rows.row.scrapCause"
                                }
                              },
                              _vm._l(_vm.devcScrapCauseList, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: { label: item.text, value: item.value }
                                })
                              })
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "departName",
                      width: "180",
                      label: "报废部门"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "staffName",
                      width: "120",
                      label: "报废人"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "comFullName",
                      width: "200",
                      label: "部门全称",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "tmpNo",
                      width: "250",
                      label: "系统编号"
                    }
                  }),
                  _vm._v(" "),
                  _vm.devcCustTag1.enabled == true
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "devcCustTag1Val",
                          label: _vm.devcCustTag1.dispName,
                          width: "120"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.devcCustTag2.enabled == true
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "devcCustTag2Val",
                          label: _vm.devcCustTag2.dispName,
                          width: "120"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.devcCustTag3.enabled == true
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "devcCustTag3Val",
                          label: _vm.devcCustTag3.dispName,
                          width: "120"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fiscalClearFlag
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "150",
                          label: "清理费用"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "itemList." +
                                        (_vm.startIndex + rows.$index) +
                                        ".theFee",
                                      rules: {
                                        validator: _vm.inputTheFee,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-content-right",
                                      attrs: { type: "text" },
                                      on: {
                                        change: function($event) {
                                          _vm.changeTheFee(rows.row)
                                        }
                                      },
                                      model: {
                                        value: rows.row.theFee,
                                        callback: function($$v) {
                                          _vm.$set(rows.row, "theFee", $$v)
                                        },
                                        expression: "rows.row.theFee"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fiscalClearFlag
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "150",
                          label: "清理收入"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "itemList." +
                                        (_vm.startIndex + rows.$index) +
                                        ".theInc",
                                      rules: {
                                        validator: _vm.inputTheInc,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-content-right",
                                      attrs: { type: "text" },
                                      on: {
                                        change: function($event) {
                                          _vm.changeTheInc(rows.row)
                                        }
                                      },
                                      model: {
                                        value: rows.row.theInc,
                                        callback: function($$v) {
                                          _vm.$set(rows.row, "theInc", $$v)
                                        },
                                        expression: "rows.row.theInc"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140",
                      label: "操作",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            !_vm.srcCheck
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.deleteDevice(rows.$index)
                                      }
                                    }
                                  },
                                  [_vm._v("移除")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.setStaffInfo(rows.$index)
                                  }
                                }
                              },
                              [_vm._v("设置人员")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pagination-layout",
                  staticStyle: { overflow: "hidden" }
                },
                [
                  _vm.totalCount > 10
                    ? _c("el-pagination", {
                        staticClass: "fr",
                        attrs: {
                          background: "",
                          "page-size": _vm.pageSize,
                          "page-sizes": _vm.pageSizes,
                          "current-page": _vm.pageNumber,
                          total: _vm.totalCount,
                          layout: "prev, pager, next, jumper, sizes, total"
                        },
                        on: {
                          "current-change": _vm.handlePageChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "例如：XXX店（店号+店名）申请XX资产报废",
                  type: "textarea",
                  resize: "both"
                },
                model: {
                  value: _vm.scrapVoucher.digest,
                  callback: function($$v) {
                    _vm.$set(_vm.scrapVoucher, "digest", $$v)
                  },
                  expression: "scrapVoucher.digest"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "swb-btn swb-btn-small",
          on: {
            click: function($event) {
              _vm.showDialogFile()
            }
          }
        },
        [_vm._v("上传")]
      ),
      _vm._v(" "),
      _vm.scrapVoucher.scrapFileList != null &&
      _vm.scrapVoucher.scrapFileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-view-list" },
            [
              _vm._m(5),
              _vm._v(" "),
              _vm._l(_vm.scrapVoucher.scrapFileList, function(fileInfo, index) {
                return [
                  _c("swb-file-item-li", {
                    attrs: {
                      trackKey: index,
                      fileName: fileInfo.name,
                      fileBrowseUrl: fileInfo.fileBrowseUrl,
                      fileDownloadUrl: fileInfo.fileBrowseUrl,
                      fileUuid: fileInfo.fileUuid,
                      deletable: true,
                      onDelete: _vm.deleteFile
                    }
                  })
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-toolbar align-center",
          staticStyle: { padding: "0" }
        },
        [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
              on: { click: _vm.prevStock }
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          !_vm.autoApplyAndAudit &&
          _vm.checkActionPerm("apply", null, _vm.scrapVoucher.comId)
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.saveScrapVoucher(true)
                    }
                  }
                },
                [_vm._v("申请")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.saveScrapVoucher(false)
                }
              }
            },
            [_vm._v("保存")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("报废单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-tip error fr font12" }, [
        _vm._v("提示:一次报废数据最多500条")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("备注信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed required" }, [
      _c("span", { staticClass: "ml5" }, [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12f332d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f332d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/scrapVoucher/ShopDeviceScrapVoucherSave.vue
// module id = 2572
// module chunks = 0